import React, { useState, useEffect } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import Loading from "../../../components/Loading/Loading";
import styles from "./ShowProListings.module.css";
import { listingStates } from "../../../util/flStates";
import DashListingCard from "../../../components/dashbaord/dashboardUtil/DashListingCard/DashListingCard";

function ShowProListings({ accessToken, userId }) {
  const [listings, setListings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [listingType, setListingType] = useState(listingStates.rent);

  useEffect(() => {
    fetchListingsData();
  }, [listingType]);

  const fetchListingsData = async () => {
    setIsLoading(true);
    try {
      const queryString = `listingType=${listingType}&userId=${userId}`;
      const url = `${
        import.meta.env.VITE_BACKEND_URL
      }/dash/pro-listings-dash?${queryString}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: accessToken,
        },
      });

      if (response.status === 200 && response.data.success) {
        setListings(response.data.listings || []);
      } else {
        const errorMsg = response.data.message || "Error fetching listings.";
        console.error(errorMsg);
      }
    } catch (error) {
      console.error("Error fetching listings: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.proListingsContainer}>
      <h2>View Your Listings</h2>

      <div className={styles.rentSellSelectionContainer}>
        <div className={styles.rentSellSelectionBox}>
          <Button
            className={`${styles.rentSellSelectionOption} ${styles.rentSellSelectionOptionLeft}`}
            variant={
              listingType === listingStates.rent ? "contained" : "outlined"
            }
            onClick={() => setListingType(listingStates.rent)}
          >
            Rent
          </Button>
          <Button
            className={`${styles.rentSellSelectionOption} ${styles.rentSellSelectionOptionRight}`}
            variant={
              listingType === listingStates.sell ? "contained" : "outlined"
            }
            onClick={() => setListingType(listingStates.sell)}
          >
            Sell
          </Button>
        </div>
      </div>

      {isLoading ? (
        <div className={styles.loadingContainer}>
          <Loading />
        </div>
      ) : (
        <div>
          {listings && listings.length ? (
            <div className={styles.listingsContainer}>
              {listings.map((listing, index) => (
                <DashListingCard key={index} listing={listing} />
              ))}
            </div>
          ) : (
            <div>No listings available.</div>
          )}
        </div>
      )}
    </div>
  );
}

export default ShowProListings;
